import { useMutation } from '@tanstack/react-query';
import { ApiResponse, ShoppingItemData } from '../types/api';
import WebApp from '@twa-dev/sdk';


const API_URL = 'https://red.sigma-dev.co.ua/mini/shop/complit';

async function fetchData(item: ShoppingItemData): Promise<ApiResponse> {
  const response = await fetch(API_URL, {
    method: 'POST',
    headers: {
      'init-data': WebApp.initData,
    },
    body: JSON.stringify({
      id: item.id,
      completed: !item.completed,
    }),

  });
  if (!response.ok) {
    throw new Error('Network response was not ok');
  }
  return response.json();
}

export function useApiShopSwitch() {
  return useMutation<ApiResponse, Error, ShoppingItemData>({
    mutationFn: fetchData,
    mutationKey: ['shopSwitch'],
  });
} 